import React, {useEffect, useState} from "react"
import paymentService from "@irati/payments/services/Payments"
import {PaymentOrder} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import tracking from "@irati-tracking/perks/perks"

interface Props {
  paymentOrder: PaymentOrder,
  redirectReturnUrl: string
}

const PaymentFormZip: React.FC<Props> = ({paymentOrder, redirectReturnUrl}) => {
  const [load, setLoad] = useState(hangPromise())
  useEffect(() => {
    tracking.paymentMethodSelected("ZIP")
    const payDetails = {
      amount: paymentOrder.amount,
      resUrl: redirectReturnUrl
    }
    setLoad(
      paymentService.payByZip(paymentOrder, payDetails).then(({details}) => {
        window.location = details.url
        return hangPromise()
      })
    )
  }, [])

  return <Loading load={load} />
}

export default PaymentFormZip
